<!-- @format -->

<template>
  <div class="home">
    <notifications group="plan" position="bottom center" />
    <div class="client-container">
      <div
        class="cbg"
        :style="
          'background: url(' +
            partnerBackgroundUrl +
            ') center center; background-size: cover;'
        "
      ></div>
      <div class="cbgmenu"></div>
      <div class="ui twelve column padded grid centered">
        <div class="row">
          <div class="twelve wide column">
            <div>
              <h2>{{ !showNewProposal ? "Plans" : "New Plan" }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="twelve wide column">
            <div
              v-if="showNewProposal"
              class="ui secondary pointing menu"
            ></div>
            <div v-if="!showNewProposal" class="ui secondary pointing menu">
              <a
                class="ui item"
                v-bind:class="{ active: filterStatus == -1 }"
                @click.prevent="refreshResults(-1, 'updated_as_at', 'desc')"
              >
                <i class="ui icon circle "></i> Show All</a
              >
              <a
                class="ui item"
                v-bind:class="{ active: filterStatus == 98 }"
                @click.prevent="refreshResults(98, 'updated_as_at', 'desc')"
              >
                <i class="ui icon circle " style="color: lightgrey"></i> Draft
              </a>
              <a
                class="ui item"
                v-bind:class="{ active: filterStatus == 99 }"
                @click.prevent="refreshResults(99, 'updated_as_at', 'desc')"
              >
                <i class="ui icon circle " style="color: orange"></i> Awaiting
                Client Signature</a
              >
              <a
                class="ui item"
                v-bind:class="{ active: filterStatus == 1 }"
                @click.prevent="refreshResults(1, 'updated_as_at', 'asc')"
              >
                <i class="ui icon circle " style="color: green"></i> Accepted</a
              >
              <a
                class="ui item"
                v-bind:class="{ active: filterStatus == 0 }"
                @click.prevent="refreshResults(0, 'full_name', 'asc')"
              >
                <i class="ui icon circle " style="color: red"></i> Rejected</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui column padded grid centered">
      <div class="row">
        <div class="twelve wide column">
          <div class="ui raised padded text segment">
            <div v-if="!showNewProposal">
              <form class="ui form" v-on:submit.prevent>
                <div class="field">
                  <sui-input
                    fluid
                    placeholder="Search ..."
                    v-model="searchText"
                    v-on:keyup="getResults(1)"
                  />
                </div>
              </form>
              <table class="ui compact table">
                <thead v-if="!loading">
                  <tr>
                    <th>Created</th>
                    <th>Client</th>

                    <th>Plan</th>

                    <th>Link to Proposal</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="!loading">
                  <tr v-for="c in finalResults" :key="c.id">
                    <td style="width: 180px">
                      {{ new Date(c.updatedAsAt) | moment("Do MMM YYYY") }}
                      <small>{{
                        new Date(c.updatedAsAt) | moment("HH:mm")
                      }}</small>
                    </td>
                    <td>
                      {{ c.fullName }}
                    </td>
                    <td>
                      <span v-if="c.status == 98">
                        <span>
                          <i
                            class="ui icon circle "
                            style="color: lightgrey"
                          ></i
                        ></span>
                      </span>
                      <span v-if="c.status == 99">
                        <span>
                          <i class="ui icon circle " style="color: orange"></i>
                        </span>
                      </span>
                      <span v-else-if="c.status == 1">
                        <i class="ui icon circle " style="color: green"></i>
                      </span>
                      <span v-else-if="c.status == 0">
                        <span>
                          <i class="ui icon circle " style="color: red"></i>
                        </span>
                      </span>
                      <router-link :to="'/v2/plans/' + c.guid">
                        {{ c.proposalName }}
                      </router-link>
                    </td>
                    <td>
                      <div
                        data-tooltip="Opens the client investment plan in a new tab"
                      >
                        <i class="ui external alternate icon"></i>
                        <a :href="proposalUrl + '?c=' + c.guid" target="_blank"
                          >View Plan</a
                        >
                      </div>
                    </td>
                    <td>
                      <sui-dropdown
                        v-if="c.status == 98 || c.status == 99"
                        text="Actions"
                        class="ui label"
                        tiny
                        button
                        pointing
                      >
                        <sui-dropdown-menu>
                          <sui-dropdown-item
                            v-if="c.status == 98"
                            @click.prevent="deletePlan(c.guid)"
                            >Delete</sui-dropdown-item
                          >
                          <sui-dropdown-item
                            v-if="c.status == 98"
                            @click.prevent="updatePlanStatus(c.id, 99)"
                            >Label as ['Awaiting Client
                            Signature']</sui-dropdown-item
                          >
                          <sui-dropdown-item
                            v-if="c.status == 99"
                            @click.prevent="updatePlanStatus(c.id, 98)"
                            >Label as ['Draft']</sui-dropdown-item
                          >
                        </sui-dropdown-menu>
                      </sui-dropdown>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="loading">
                  <tr>
                    <td>
                      <div
                        class="hollow-dots-spinner"
                        v-if="loading"
                        :style="spinnerStyle"
                      >
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <sui-menu v-if="totalPages > 1" v-sui-floated:right pagination>
                <a is="sui-menu-item" @click.prevent="getResults(1)" icon>
                  <sui-icon name="left chevron" />First Page
                </a>
                <a
                  is="sui-menu-item"
                  v-if="
                    currentPageNr - 4 > 0 && currentPageNr - 4 <= totalPages
                  "
                  @click.prevent="getResults(currentPageNr - 4)"
                  >{{ currentPageNr - 4 }}</a
                >
                <a
                  is="sui-menu-item"
                  v-if="
                    currentPageNr - 3 > 0 && currentPageNr - 3 <= totalPages
                  "
                  @click.prevent="getResults(currentPageNr - 3)"
                  >{{ currentPageNr - 3 }}</a
                >
                <a
                  is="sui-menu-item"
                  v-if="
                    currentPageNr - 2 > 0 && currentPageNr - 2 <= totalPages
                  "
                  @click.prevent="getResults(currentPageNr - 2)"
                  >{{ currentPageNr - 2 }}</a
                >
                <a
                  is="sui-menu-item"
                  v-if="
                    currentPageNr - 1 > 0 && currentPageNr - 1 <= totalPages
                  "
                  @click.prevent="getResults(currentPageNr - 1)"
                  >{{ currentPageNr - 1 }}</a
                >
                <div is="sui-menu-item">
                  <strong>{{ currentPageNr }}</strong>
                </div>

                <a
                  is="sui-menu-item"
                  v-if="
                    currentPageNr + 1 > 0 && currentPageNr + 1 <= totalPages
                  "
                  @click.prevent="getResults(currentPageNr + 1)"
                  >{{ currentPageNr + 1 }}</a
                >
                <a
                  is="sui-menu-item"
                  v-if="
                    currentPageNr + 2 > 0 && currentPageNr + 2 <= totalPages
                  "
                  @click.prevent="getResults(currentPageNr + 2)"
                  >{{ currentPageNr + 2 }}</a
                >
                <a
                  is="sui-menu-item"
                  v-if="
                    currentPageNr + 3 > 0 && currentPageNr + 3 <= totalPages
                  "
                  @click.prevent="getResults(currentPageNr + 3)"
                  >{{ currentPageNr + 3 }}</a
                >
                <a
                  is="sui-menu-item"
                  v-if="
                    currentPageNr + 4 > 0 && currentPageNr + 4 <= totalPages
                  "
                  @click.prevent="getResults(currentPageNr + 4)"
                  >{{ currentPageNr + 4 }}</a
                >

                <a
                  is="sui-menu-item"
                  icon
                  @click.prevent="getResults(totalPages)"
                >
                  <sui-icon name="right chevron" />Last Page
                </a>
              </sui-menu>
              <div
                class="ui large primary button"
                v-if="!showNewProposal"
                @click="showNewProposal = true"
              >
                Create New Plan
              </div>
            </div>

            <div class="ui  segment" v-show="showNewProposal">
              <NewProposal :clientId="-1" />
            </div>
            <div class="ui segment" v-show="showNewProposal">
              <a href="#" @click.prevent="showNewProposal = false">Cancel</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProposalsV2,
  createClient,
  ProposalUrl,
  deleteProposalsV2,
  updateProposalStatusV2,
} from "@/gateway";
import moment from "moment";
import NewProposal from "@/components/NewProposal";
export default {
  name: "ProposalList",
  components: { NewProposal },
  props: {
    msg: String,
  },
  data() {
    return {
      proposalUrl: "",
      // new client
      message: "",
      clientFirstName: "",
      clientLastName: "",
      currentAge: 55,
      email: "",
      birthday: null,
      showNewProposal: false,
      //
      results: [],
      filterStatus: -1,
      searchText: "",
      orderBy: "updated_as_at",
      order: "desc",
      loading: false,
      totalRecords: 0,
      currentPageNr: 1,
      currentPageSize: 5,
      totalPages: 1,
      allRecords: {
        saved: 0,

        archived: 0,
      },
    };
  },
  computed: {
    canSave() {
      if (
        this.clientFirstName != "" &&
        this.clientLastName != "" &&
        this.email != ""
      ) {
        return true;
      } else return false;
    },
    finalResults() {
      return this.results;
    },
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    },
  },
  methods: {
    async deletePlan(guid) {
      const response = await deleteProposalsV2({ guid: guid });
      if (response) {
        if (response.success) {
          this.$notify({
            group: "plan",
            title: "Plan deleted",
            position: "bottom right",
            type: "success",
          });
          this.refreshResults(this.filterStatus);
        } else {
          this.$notify({
            group: "plan",
            title: "Plan not deleted " + response.message,
            position: "bottom right",
            type: "success",
          });
        }
      }
    },
    async updatePlanStatus(id, status) {
      const response = await updateProposalStatusV2({ id: id, status: status });
      if (response) {
        if (response.success) {
          this.$notify({
            group: "plan",
            title: "Plan status updated",
            position: "bottom right",
            type: "success",
          });
          this.refreshResults(this.filterStatus);
        } else {
          this.$notify({
            group: "plan",
            title: "Plan status not updated " + response.message,
            position: "bottom right",
            type: "error",
          });
        }
      }
    },
    calculateAge(arg) {
      return moment().diff(moment(arg, "YYYY-MM-DD"), "years");
    },
    formatDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYY-MM-DD").format(fmt);
      else return moment(arg, "YYYY-MM-DD").format("DD MMM YYYY HH:mm");
    },
    friendlyDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYYMMDD").format(fmt);
      else return moment(arg, "YYYYMMDD").format("DD MMM YYYY HH:mm");
    },
    async saveClient() {
      var response = await createClient({
        clientView: {
          id: 0,
          firstName: this.clientFirstName,
          lastName: this.clientLastName,
          primaryEmail: this.email,
          birthday: this.birthday,
        },
      });
      if (response) {
        this.showNewProposal = false;
        this.message =
          response.result == true ? "Success" : "Error creating client";
        this.init();
      }
    },
    async refreshResults(filterStatus, orderBy, ord) {
      this.filterStatus = filterStatus;
      this.pageNr = 1;
      this.orderBy = orderBy;
      this.order = ord;
      this.getResults(1);
    },
    async getResults(pageNr, filterStatus) {
      if (filterStatus) this.filterStatus = filterStatus;
      this.loading = true;
      //  await new Promise(r => setTimeout(r, 2000));
      var response = await getProposalsV2({
        searchText: this.searchText,
        pageSize: this.currentPageSize,
        pageNr: pageNr,
        status: this.filterStatus,
        partnerId: this.$store.state.partnerId,
        orderBy: this.orderBy,
        order: this.order,
      });
      // console.log(response);
      this.totalRecords = response.totalRecords;
      this.totalPages = response.totalPages;
      this.currentPageNr = response.currentPageNr;
      this.results = response.result;
      this.loading = false;
    },
    async getResultCount(filterStatus) {
      var response = await getProposalsV2({
        pageSize: 100000,
        pageNr: 1,
        status: filterStatus,
        partnerId: this.$store.state.partnerId,
      });
      //   console.log(response.totalRecords);

      if (filterStatus == "Saved")
        this.allRecords.saved = response.totalRecords;

      if (filterStatus == "Archived")
        this.allRecords.archived = response.totalRecords;
      //    console.log(this.allRecords);
    },
    async archivePlan(id) {
      //  console.log(" archiving plan " + id);
      /* const response = await updatePlanStatus({ id: id, status: "Archived" });
      console.log(response);
      if ((response.success = 1)) {
        await this.getResults(1);
        await this.getResultCount("Saved");
        await this.getResultCount("Archived");
      }*/
    },
    async movePlanToSaved(id) {
      /* const response = await updatePlanStatus({ id: id, status: "Saved" });
      if ((response.success = 1)) {
        await this.getResults(1);
        await this.getResultCount("Saved");
        await this.getResultCount("Archived");
      }*/
    },
    async init() {
      this.allRecords.saved = 0;
      this.allRecords.archived = 0;
      await this.getResults(1);
      //  await this.getResultCount("Saved");
      //  await this.getResultCount("Archived");
    },
  },
  async mounted() {
	  var domainName = "portfoliolink.co.za";
	  if (this.$store.state.appName.toLowerCase() == "questlink")
	  {
		  domainName = "questlink.app";
	  }
    this.proposalUrl = ProposalUrl.replace("portfoliolink.co.za",domainName);
    this.init();
  },
};
</script>
